import styled from 'styled-components';

export const DeliveryForm = styled.form`
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/delivery/styles.jsx